// ---------------------------------------------------------------------------
// react-admin style query params (sort / range / filter)
//
// Shared source of truth for the RA-list query helper used by the admin,
// billing, prices and provider data-fetching hooks. Previously each
// entities/*/api.ts re-declared these types and a near-identical `raParams`
// helper with slightly diverging `extra` signatures — this is the superset.
// ---------------------------------------------------------------------------

export type RASort = [field: string, order: "ASC" | "DESC"];
export type RARange = [start: number, end: number];
export type RAFilter = Record<string, unknown>;

export type RAParamValue = string | boolean;
export type RAParams = Record<string, RAParamValue>;

/**
 * Build a query-param object from react-admin sort/range/filter triples.
 *
 * `sort`/`range`/`filter` are JSON-stringified when present; `extra` is merged
 * in as-is (covers prices `{ mode }` and provider `{ secret }`). The returned
 * `Record<string, string | boolean>` is assignable to the `params` argument of
 * `apiGetWithTotal` / `billingGetWithTotal`.
 */
export function raParams(
    sort?: RASort,
    range?: RARange,
    filter?: RAFilter,
    extra?: Record<string, RAParamValue>,
): RAParams {
    const params: RAParams = { ...(extra ?? {}) };
    if (sort) params.sort = JSON.stringify(sort);
    if (range) params.range = JSON.stringify(range);
    if (filter) params.filter = JSON.stringify(filter);
    return params;
}
